/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { confirmWrapper } from 'src/components/Dialog/PromiseDialog';
import { CircularProgress } from '@mui/material';
import { DialogContentProps } from 'src/components/Dialog/Dialog';
import UploadResume from './UploadResume';
import { ResumeData } from '../types';
import ConsentPopup from './AssesmentConsent';
import AssesmentNew from './AssesmentNew';
import { applyJob, uploadResume } from '../utils';
import API from '../../../network';
import NewAssesmentComplete from './NewAssesmentComplete';

type Step = 'application' | 'consent' | 'assessment' | 'complete';

interface ApplyJobProps extends DialogContentProps {
  jobOrderId: number;
  orgId: number;
  jdText: string;
  jobTitle: string;
}
export default function ApplyJob({
  jobOrderId, orgId, jdText, jobTitle, proceed,
}: ApplyJobProps) {
  const [resumePath, setResumePath] = useState('');
  const [resumeName, setResumeName] = useState('');
  const [candidateId, setCandidateId] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState<Step>('application');
  const [sessionId, setSessionId] = useState('');
  const [evaluation, setEvaluation] = useState('');
  const [candidateName, setCandidateName] = useState('');

  const onUploadResume = async (e: React.ChangeEvent<HTMLInputElement>): Promise<{ response: ResumeData | null, error: string }> => {
    const file = e.target.files?.[0];
    if (!file) {
      return { response: null, error: '' };
    }
    const { response, error, resumeName: resumeNameLocal } = await uploadResume(file, orgId);
    if (error) {
      await confirmWrapper(error, {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
    setCandidateName(`${response?.firstName} ${response?.lastName}`);
    setResumePath(response?.s3DownloadLink || '');
    setResumeName(resumeNameLocal);
    return { response, error };
  };

  const onApplyJob = async (formValues: any, resumeData: ResumeData) => {
    setLoading(true);
    try {
      const { candidateId: candidateIdLocal } = await applyJob(formValues, resumeData, orgId, jobOrderId);
      setCandidateId(candidateIdLocal || '');
      setStep('consent');
    } catch (error) {
      if (error instanceof Error) {
        await confirmWrapper(error.message, {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      }
      setResumeName('');
    } finally {
      setLoading(false);
    }
  };

  const handleProceed = async () => {
    try {
      setLoading(true);
      setStep('assessment');
      const response = await API.getInstance().startAssesment({
        resume_path: resumePath, jd_text: jdText, jobOrderId: jobOrderId.toString(), candidate_id: candidateId.toString(),
      });
      setSessionId(response.session_id);
    } catch (error) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      setLoading(false);
    }
  };
  const handleEndAssessment = async () => {
    try {
      setLoading(true);
      const response = await API.getInstance().endAssessment({ session_id: sessionId });
      setEvaluation(response.evaluation_feedback_message);
    } catch (error) {
      await confirmWrapper(
        'Error ending assessment',
        {
          variant: 'danger',
          hidePrimaryBtn: true,
          hideSecondaryBtn: true,
          fullWidth: true,
          showCloseButton: true,
        },
      );
    } finally {
      setStep('complete');
      setLoading(false);
    }
  };

  const handleSubmitFeedback = async (rating: 'positive' | 'negative') => {
    if (proceed) {
      proceed();
    }
    try {
      await API.getInstance().submitUserFeedback({ session_id: sessionId, user_feedback: rating, total_time: '' });
    } catch (error) {
      await confirmWrapper(
        'Error rating assessment',
        {
          variant: 'danger',
          hidePrimaryBtn: true,
          hideSecondaryBtn: true,
          fullWidth: true,
          showCloseButton: true,
        },
      );
    }
  };

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center gap-8 w-[630px] h-[500px]">
        <CircularProgress className="w-40 h-40 text-[#00349A]" />
      </div>
    );
  }

  switch (step) {
    case 'application':
      return (
        <UploadResume
          loading={loading}
          onApplyJob={onApplyJob}
          organizationId={orgId}
          onUploadResume={onUploadResume}
          resumeName={resumeName}
          setResumeName={setResumeName}
        />
      );

    case 'consent':
      return (
        <ConsentPopup
          proceed={proceed || (() => { })}
          candidateName={candidateName}
          jobTitle={jobTitle}
          handleProceed={handleProceed}
          resumeName={resumeName}
        />
      );

    case 'assessment':
      return (
        <AssesmentNew
          candidateName={candidateName}
          setGlobalLoading={setLoading}
          resumeName={resumeName}
          jobTitle={jobTitle}
          sessionId={sessionId}
          endAssesment={handleEndAssessment}
        />
      );

    case 'complete':
      return (
        <NewAssesmentComplete
          candidateName={candidateName}
          resumeName={resumeName}
          jobTitle={jobTitle}
          evaluation={evaluation}
          handleSubmitFeedback={handleSubmitFeedback}
        />
      );
    default:
      return <div>Unknown step</div>;
  }
}
